export enum ErrorMessages {
  DEFAULT = 'Something went wrong!',
  SERVER_ERROR = 'Server error',
  APP_SESSION_EXPIRED = 'Your session has expired. Please login again',
}

export enum ErrorCodes {
  BD_UNAUTHORIZED = 'BD_UNAUTHORIZED',
  INACTIVE_TOKEN = 'INACTIVE_TOKEN',
  INACTIVE_CLIENT = 'INACTIVE_CLIENT',
  BD_USER_WORKSPACE_ACCESS_DENIED = 'BD_USER_WORKSPACE_ACCESS_DENIED',
  BD_CLIENT_NOT_FOUND = 'BD_CLIENT_NOT_FOUND',
}
